import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { Icon } from '~/modules/elements/akui/icon';

interface Props {
  video?: string;
  className?: string;
  iconSize?: number;
}

// The music note sits behind the picture, so a song with no video or a thumbnail that fails to load
// still shows a tile rather than a hole.
export default function SongThumbnail({ video, className, iconSize = 6.5 }: Props) {
  const [failed, setFailed] = useState<string | null>(null);
  const showImage = !!video && failed !== video;

  return (
    <span
      aria-hidden
      data-test="song-thumbnail"
      className={twMerge(
        'relative flex size-14 shrink-0 items-center justify-center overflow-hidden rounded-[0.625rem] bg-white/8 text-white/35',
        className,
      )}>
      <Icon icon="ic:baseline-music-note" size={iconSize} />
      {showImage && (
        <img
          src={`https://i.ytimg.com/vi/${video}/mqdefault.jpg`}
          alt=""
          loading="lazy"
          onError={() => setFailed(video)}
          className="absolute inset-0 size-full object-cover"
        />
      )}
    </span>
  );
}
